import { render, staticRenderFns } from "./SingleNumberFrameLaptops.vue?vue&type=template&id=304a5438&"
import script from "./SingleNumberFrameLaptops.vue?vue&type=script&lang=js&"
export * from "./SingleNumberFrameLaptops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports